import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { ShoppingBag, FileText, MessageSquare } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function MobileStickyCTA() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      // Show after scrolling down a bit
      setIsVisible(window.scrollY > 300);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <AnimatePresence data-id="element-130">
      {isVisible && <motion.div initial={{
      y: 100
    }} animate={{
      y: 0
    }} exit={{
      y: 100
    }} className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 shadow-[0_-4px_6px_-1px_rgba(0,0,0,0.1)] z-40 lg:hidden" data-id="element-131">
          <div className="flex justify-around items-center p-2 pb-safe" data-id="element-132">
            <Link to="/shop" className="flex flex-col items-center p-2 text-gray-600 hover:text-yarbo-dark flex-1" data-id="element-133">
              <ShoppingBag className="w-5 h-5 mb-1" data-id="element-134" />
              <span className="text-[10px] font-medium uppercase tracking-wider" data-id="element-135">
                Shop
              </span>
            </Link>
            <Link to="/contact" className="flex flex-col items-center p-2 text-yarbo-dark flex-1 relative" data-id="element-136">
              <div className="absolute -top-6 bg-yarbo-yellow rounded-full p-3 shadow-lg border-4 border-white" data-id="element-137">
                <FileText className="w-5 h-5" data-id="element-138" />
              </div>
              <span className="text-[10px] font-bold uppercase tracking-wider mt-6" data-id="element-139">
                Quote
              </span>
            </Link>
            <Link to="/contact" className="flex flex-col items-center p-2 text-gray-600 hover:text-yarbo-dark flex-1" data-id="element-140">
              <MessageSquare className="w-5 h-5 mb-1" data-id="element-141" />
              <span className="text-[10px] font-medium uppercase tracking-wider" data-id="element-142">
                Contact
              </span>
            </Link>
          </div>
        </motion.div>}
    </AnimatePresence>;
}